import authorizedAxios from "../../helpers/authorizedAxios";
import { getProductStockLimit } from "../../pages/PosPage/productCatalog";

// Tidak memakai katalog terfilter/paginasi: setiap item diperiksa langsung ke API.
export const validateRecoveredCart = async (snapshot) => {
  const details = [];
  const warnings = [];
  for (let offset = 0; offset < snapshot.details.length; offset += 6) {
    const items = await Promise.all(snapshot.details.slice(offset, offset + 6).map(async (saved) => {
      let product;
      try {
        const response = await authorizedAxios.get(`/products/${saved.product_id}`);
        product = response.data?.data;
      } catch (error) {
        if (error?.response?.status !== 404) throw error;
      }
      if (!product?.id || product.deleted_at || product.is_available === false || Number(product.is_available) === 0) {
        return { warning: `${saved.product_name} sudah tidak tersedia dan dikeluarkan dari keranjang.` };
      }
      const price = Number(product.unit_price);
      if (!Number.isFinite(price) || price < 0) throw new Error("Harga produk belum bisa dicek. Coba lagi.");
      const capacity = product.can_sell === false ? 0 : getProductStockLimit(product);
      const name = product.product_group_name && product.variant_label
        ? `${product.product_group_name} - ${product.variant_label}` : product.name;
      const notes = [];
      if (price !== saved.unit_price) notes.push(`${name}: harga diperbarui.`);
      if (saved.qty > capacity) notes.push(`${name}: tersedia ${capacity}, di keranjang ${saved.qty}. Kurangi jumlahnya sebelum bayar.`);
      return {
        notes,
        detail: {
          product_id: product.id, product_name: name, product_group_name: product.product_group_name,
          variant_label: product.variant_label, qty: saved.qty, unit: product.unit,
          unit_price: price, unit_cogs: product.unit_cogs, weight: product.weight,
          subtotal: price * saved.qty, stock_available: Number.isFinite(capacity) ? capacity : null,
          stock_unlimited: !Number.isFinite(capacity), inventory_mode: product.inventory_mode,
          image: product.image, image_path: product.image_path || product.image,
          image_url: product.image_path || product.image, note: saved.note,
        },
      };
    }));
    items.forEach((item) => {
      if (item.detail) details.push(item.detail);
      warnings.push(...(item.notes || []), ...(item.warning ? [item.warning] : []));
    });
  }
  let customerId = snapshot.customer_id;
  if (customerId !== 1) {
    try {
      const response = await authorizedAxios.get(`/customers/${customerId}`);
      if (!response.data?.data?.id || response.data.data.deleted_at) customerId = 1;
    } catch (error) {
      if (error?.response?.status !== 404) throw error;
      customerId = 1;
    }
    if (customerId === 1) warnings.push("Pelanggan tidak ditemukan. Diganti ke Umum.");
  }
  return { details, warnings, customerId };
};
